import { Helmet } from 'react-helmet';

function HelmetThemeColor({ color = "#fff" }) {
  return (
    <Helmet><meta name="theme-color" content={color} /></Helmet>
  )
}

export default HelmetThemeColor